import { createAction, props } from '@ngrx/store';
import { IMaps } from 'src/app/models/map';

export const GetMapsApiAction = createAction('[Maps] - Get Maps');

export const SuccessGetMapsApiAction = createAction(
    '[Maps] - Success Get Maps',
    props<{ mapObject: IMaps }>()
);

export const ErrorGetMapsApiAction = createAction('[Maps] - Error', props<Error>());
